import { AbstractRemarksForm, AbstractRemarksFormProps, State } from "./OwnershipChangeFrom";
import { ITabuSmartService, PropertyAnnexRequest, TabuLookUp, TabuProcedures, TabuRequestApi } from "@10x/tabu-mobile-api";
import { ProcedureDetail, TabuRequestSubmitResponse } from "@10x/tabu-mobile-api/dist/requests/entity";
import BaseTabuRequestForm, { BaseTabuRequestProps } from "./BaseTabuRequestForm";
import React from "react";

interface AnnexProps extends Partial<AbstractRemarksFormProps> {
	documentLookupName: () => string | undefined;
	procedure: ITabuSmartService;
	submitApi: <T extends PropertyAnnexRequest>( request: T ) => Promise<TabuRequestSubmitResponse>;
}

class AbstractAnnexForm extends BaseTabuRequestForm<AnnexProps & BaseTabuRequestProps, State> {
	render() {
		return <AbstractRemarksForm
			initialState={ this.initialState }
			previousRequestId={ this.previousRequestId }
			previousDocs={ this.previousDocs }
			{ ...this.props }/>;
	}

	initialState = ( previousRequest?: ProcedureDetail ) => {
		const oldRemark = previousRequest?.AnnexDetails?.Remarks;
		if ( oldRemark ) {
			return {
				notes: oldRemark,
			};
		}
		return {};
	};

	previousRequestId = ( previousRequest?: ProcedureDetail ) => {
		return previousRequest?.AnnexDetails?.Identity ?? undefined;
	};

	previousDocs = ( previousRequest?: ProcedureDetail ) => {
		return previousRequest?.AnnexDetails?.Documents ?? undefined;
	};
}

export class PropertyAnnexForm extends BaseTabuRequestForm<BaseTabuRequestProps, State> {
	render() {
		return <AbstractAnnexForm
			submitApi={ TabuRequestApi.submitPropertyAnnexRequest }
			procedure={ TabuProcedures.PropertyAnnex }
			documentLookupName={ this.documentLookupName }
			{ ...this.props }/>;
	}

	documentLookupName = () => {
		return TabuLookUp.PROPERTY_ANNEX_DOCUMENTS;
	};
}

export class DelayedPropertyAnnexForm extends BaseTabuRequestForm<BaseTabuRequestProps, State> {
	render() {
		return <AbstractAnnexForm
			submitApi={ TabuRequestApi.submitDelayedPropertyAnnexRequest }
			procedure={ TabuProcedures.DelayedPropertyAnnex }
			documentLookupName={ this.documentLookupName }
			{ ...this.props }/>;
	}

	documentLookupName = () => {
		return TabuLookUp.DELAYED_PROPERTY_ANNEX_DOCUMENTS;
	};
}
